var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37867 38.665C6.07224 38.4469 6.67182 38.0149 7.08468 37.4358C7.49866 36.8485 7.71934 36.1548 7.71797 35.4451V15.9911C7.7152 14.8601 7.92177 13.7378 8.328 12.6766C8.69973 11.6034 9.32533 10.6281 10.1555 9.82742C12.0709 8.05322 14.6428 7.98604 15.0926 7.98355C17.8093 7.98355 20.5441 9.45915 21.7951 11.8554C22.4146 13.0529 22.6486 14.4011 22.4672 15.7273C22.232 17.3025 21.4333 18.3575 20.4562 19.5992C18.2358 22.4335 16.7133 22.5081 16.4341 24.1181C16.1756 25.5713 17.1036 27.3529 18.4452 27.99C21.0507 29.2167 25.1477 26.0465 27.1587 23.4711C30.046 19.7809 30.6173 14.7444 29.1749 10.5739C28.3342 8.16616 26.8403 6.01844 24.8479 4.35303C22.3013 2.26377 19.1089 1.04339 15.7672 0.881766C15.7672 0.881766 6.8081 0.182547 2.47328 7.50081C1.26858 9.60478 0.652212 11.9739 0.68456 14.3761V34.9847C0.68456 35.0917 0.849993 37.4955 2.82224 38.4386C3.61317 38.8252 4.52773 38.9063 5.37867 38.665Z",
    fill: "url(#paint0_linear_1_474)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_474",
    x1: 1.92013,
    y1: 23.4039,
    x2: 26.9158,
    y2: 7.47901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#419FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4B85FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5274FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLogo);
export default __webpack_public_path__ + "static/media/vector-logo.edef92799748fe3e34c7329045ae355e.svg";
export { ForwardRef as ReactComponent };